import React from 'react';
import { Input, Button, Message, Form } from '@gasbuddy/react-components';
import shared from '../../styles/shared.css';

const {
  api,
  logOut,
  invokeCallback,
  getCurrentAppOrganizations,
  setOrganizationForSession,
  saveUserSession,
  processLoginResponse,
  getSupportEmail,
  isEmail,
  setEmergencyStatus,
} = require('../../../lib/bputils').default;

class LoginForm extends React.Component {
  state = {
    isLoading: false,
    email: '',
    password: '',
    hasError: false,
    errorMessageHeader: '',
    errorMessageContent: '',
  }

  componentDidMount = () => {
    this.autofocusedInput.focus();
    logOut(false);
  }

  setDefaultOrgAsCurrentOrg(retry, errorCallback) {
    const self = this;
    api.get({
      path: '/organizations',
      requestId: 'loadAvailableOrganizations',
      error(err) {
        if (retry) {
          self.setDefaultOrgAsCurrentOrg(false, errorCallback);
        }
        invokeCallback(errorCallback, err);
      },
      success({ emergency_status: emergencyStatus, organizations: orgs }) {
        const currentAppOrgs = getCurrentAppOrganizations(orgs);
        if (currentAppOrgs.length > 0) {
          // Set "first app-specific org" as selected-org
          // (later user will be able to set default-org in user-profile)
          let defaultSelectedOrgId = currentAppOrgs[0].organization_id;
          const americanOil = currentAppOrgs.find(o => o.name === 'americanoil');
          if (americanOil) {
            defaultSelectedOrgId = americanOil.organization_id;
          }
          setOrganizationForSession(defaultSelectedOrgId, errorCallback);
          setEmergencyStatus(emergencyStatus);
        } else {
          self.setState({
            hasError: true,
            errorMessageHeader: 'Your organization(s) has not subscribed to Business Pages',
            errorMessageContent: '',
          });
        }
      },
    });
  }

  login = () => {
    this.setState({
      isLoading: true,
    });
    const { email, password } = this.state;
    const self = this;
    api.post({
      path: '/session',
      data: {
        email,
        password,
      },
      contentType: 'application/json',
      error(error) {
        let errorHeader = '';
        const errorMessageContent = `
          We don't recognize that email address/password combination.
          Please try again.`;
        if (error.status === 401) {
          errorHeader = 'Let\'s try that again';
        } else {
          errorHeader = 'Hmmm...something\'s not right';
        }
        self.setState({
          isLoading: false,
          hasError: true,
          errorMessageHeader: errorHeader,
          errorMessageContent,
        });
      },
      success(res) {
        if (res.profile) {
          processLoginResponse(res);
        } else {
          saveUserSession(res);
          const errorCallback = () => {
            const supportEmail = getSupportEmail();
            self.setState({
              isLoading: false,
              hasError: true,
              errorMessageHeader: 'Could not login',
              errorMessageContent: `An error occurred, please try again or contact support at <a href="mailto:${supportEmail}">${supportEmail}</a>.`,
            });
          };
          self.setDefaultOrgAsCurrentOrg(true, errorCallback);
        }
      },
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { email, password } = this.state;

    let errorMessage = '';
    if (isEmail(email) && password.length) {
      this.login(email, password);
      this.setState({ hasError: false });
    } else {
      if (!isEmail(email)) {
        errorMessage += 'Valid email address is required. ';
      }
      if (!password.length) {
        errorMessage += 'Password is required';
      }
    }
    if (errorMessage.length) {
      this.setState({
        hasError: true,
        errorMessageHeader: 'Missing required field(s)',
        errorMessageContent: errorMessage,
      });
    }
  }

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  }

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value });
  }

  render() {
    const { isLoading, hasError, errorMessageHeader, errorMessageContent } = this.state;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Input
          label="Enter your email"
          type="email"
          name="email"
          onChange={this.handleEmailChange}
          ref={(e) => { this.autofocusedInput = e; }}
        />
        <Input
          label="Password"
          type="password"
          onChange={this.handlePasswordChange}
        />
        { hasError ? (
          <Message color="red" dismissable>
            {`${errorMessageHeader}. ${errorMessageContent}`}
          </Message>
        ) : null }

        <Button
          type="submit"
          rounded
          color="teal"
          loading={isLoading}
          className={shared.fullWidth}
        >
          Sign In
        </Button>
      </Form>
    );
  }
}

export default LoginForm;
